import { buildConfirmResetPasswordForm, buildResetPasswordForm } from "app/client/ui/ForgotPasswordForms";
import { LoginAPIImpl } from "app/client/ui/LoginAPI";
import * as css from "app/client/ui/LoginPagesCss";
import { buildVerifyEmailForm } from "app/client/ui/SignupForms";
import { getPageTitleSuffix } from "app/common/gristUrls";
import { getGristConfig } from "app/common/urlUtils";

import { Disposable, dom, Observable } from "grainjs";

export class ForgotPasswordPage extends Disposable {
  private _currentStep: Observable<"reset-password" | "confirm-reset-password" | "verify-email"> =
    Observable.create(this, "reset-password");

  private _email = Observable.create(this, "");
  // Set after first form is successfully submitted; differs from _email in that
  // this value may either be a Cognito user id or an email address, depending on
  // whether the Grist user has already been linked to a Cognito user.
  private _username: string;
  private _loginAPI = new LoginAPIImpl();

  public buildDom() {
    const suffix = getPageTitleSuffix(getGristConfig());
    document.title = `Sign in${suffix}`;

    return css.pageContainer(this._buildPasswordResetForms());
  }

  private _buildPasswordResetForms() {
    return css.flexJustifyCenter(css.formContainer(
      dom.domComputed(this._currentStep, (currentStep) => {
        switch (currentStep) {
          case "reset-password": {
            return dom.create(buildResetPasswordForm, {
              loginAPI: this._loginAPI,
              email: this._email,
              onSuccess: ({ username }) => {
                this._username = username;
                this._currentStep.set("confirm-reset-password");
              },
              onEmailVerificationRequired: () => {
                this._currentStep.set("verify-email");
              },
            });
          }
          case "confirm-reset-password": {
            return dom.create(buildConfirmResetPasswordForm, {
              loginAPI: this._loginAPI,
              email: this._email,
              username: this._username,
            });
          }
          case "verify-email": {
            return dom.create(buildVerifyEmailForm, {
              loginAPI: this._loginAPI,
              email: this._email,
              headingText: "Verification Required",
              footer: () => css.text(
                css.textButton("← Back",
                  dom.on("click", () => {
                    this._email.set("");
                    this._currentStep.set("reset-password");
                  }),
                ),
              ),
            });
          }
        }
      }),
    ));
  }
}
